import React, { ReactNode, useState } from 'react';
import { Button, Input, Modal } from 'antd';

interface IProps {
  open: boolean;
  title: string;
  content: string;
  handleOk: (remark: string) => void;
  handleCancel: () => void;
  loading?: boolean;
  showInfo?: boolean;
  info?: ReactNode;
}

const RejectModal = ({
  open,
  content,
  handleOk,
  handleCancel,
  loading,
  showInfo,
  info,
}: IProps) => {
  const [remark, setRemark] = useState('');
  return (
    <Modal
      width={400}
      open={open}
      onOk={() => handleOk(remark)}
      onCancel={handleCancel}
      okText="ตกลก"
      cancelText="ยกเลิก"
      footer={
        <div className="">
          <Input.TextArea
            rows={3}
            placeholder="ระบุหมายเหตุที่ยกเลิกเอกสาร"
            onChange={(e) => setRemark(e.target.value)}
            value={remark}
          />
          <Button key="back" onClick={handleCancel} className={'mt-3'}>
            ยกเลิก
          </Button>
          <Button
            key="submit"
            type="primary"
            form="unit"
            onClick={() => {
              if (remark) handleOk(remark);
            }}
            className="m-2 bg-danger"
            loading={loading}
          >
            ยืนยัน
          </Button>
        </div>
      }
      afterClose={() => setRemark('')}
    >
      <div className="">
        <div>{content}</div>
      </div>
      {showInfo && info}
    </Modal>
  );
};

export default RejectModal;
